// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"de6bdd11","141":"2ca8c1b9","234":"155bfbc9","747":"8fd0c3b2","985":"2b3738fb"}[chunkId] + ".chunk.js";
};